module.exports = __webpack_public_path__ + "static/media/laymen-video-share.1a174179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viewer-consent/laymen-video-share.png
// module id = 257
// module chunks = 0